import { BaseIngredientTabProps } from 'components/desktop/BaseIngredient/BaseIngredientComponent';
import 'components/desktop/BaseIngredient/BaseIngredientComponent.scss';
import { BaseIngredientAllergenCard } from 'components/desktop/BaseIngredient/Cards/BaseIngredientAllergenCard';
import { BaseIngredientCharacteristicsCard } from 'components/desktop/BaseIngredient/Cards/BaseIngredientCharacteristicsCard';
import { BaseIngredientDensityCard } from 'components/desktop/BaseIngredient/Cards/BaseIngredientDensityCard';
import { BaseIngredientIngredientCard } from 'components/desktop/BaseIngredient/Cards/BaseIngredientIngredientCard';
import { BaseIngredientScalingFactorCard } from 'components/desktop/BaseIngredient/Cards/BaseIngredientScalingFactorCard';
import { BaseIngredientSeasonsCard } from 'components/desktop/BaseIngredient/Cards/BaseIngredientSeasonsCard';
import { BaseIngredientTagsCard } from 'components/desktop/BaseIngredient/Cards/BaseIngredientTagsCard';
import { BaseIngredientUnitWeightsCard } from 'components/desktop/BaseIngredient/Cards/BaseIngredientUnitWeightsCard';
import { BaseIngredientNameInputs } from 'components/desktop/BaseIngredient/Inputs/BaseIngredientNameInputs';
import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import PictureBig from 'components/desktop/_general/PictureBig/PictureBig';
import PictureUpload from 'components/desktop/_general/PictureUpload/PictureUpload';
import PERMISSIONS from 'enums/permissions';
import { getPicturePath } from 'functions/getPicturePath';
import { arePermissionsInUserPermissions } from 'functions/tokenFunctions';

const TabGeneral = (props: BaseIngredientTabProps) => {
	const isBaseIngredientEditor: boolean = arePermissionsInUserPermissions([
		PERMISSIONS.WRITEBASEINGREDIENT,
	]);

	return (
		<div className="row mt-4">
			<div className="col-md-4 col-xl-3 col-sm-12 col-12 sidebar">
				<PictureBig path={getPicturePath(props.state.image, 376)} />
				<div className="margin-top-5">
					<RenderIf condition={isBaseIngredientEditor}>
						<PictureUpload setFormData={props.handlers.uploadImage} />
					</RenderIf>
				</div>
			</div>
			<div className="col-md-8 col-xl-9 col-sm-12 col-12">
				<BaseIngredientNameInputs {...props} />
				<div className="row" style={{ marginTop: '50px' }}>
					<div className="col-4 d-flex flex-column" style={{ gap: '15px' }}>
						<BaseIngredientIngredientCard {...props} />
						<BaseIngredientScalingFactorCard {...props} />
						<BaseIngredientCharacteristicsCard {...props} />
						<BaseIngredientUnitWeightsCard {...props} />
						<BaseIngredientDensityCard {...props} />
						<BaseIngredientTagsCard {...props} />
					</div>
					<div className="col-4 d-flex flex-column" style={{ gap: '15px' }}>
						<BaseIngredientAllergenCard {...props} />
					</div>
					<div className="col-4 d-flex flex-column" style={{ gap: '15px' }}>
						<BaseIngredientSeasonsCard {...props} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default TabGeneral;
